/**
 * x_tarificador-cart-rates-popup.js
 * Manejo del popup del header para selección de ubicación
 */
(function() {
  'use strict';
  
  window.HACIENDOLA = window.HACIENDOLA || {};
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR || {};
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS || {};
  
  /**
   * Abre el popup de selección de ubicación
   */
  window.openShippingPopup = () => {
    const popup = document.getElementById('shippingPopup');
    if (popup) {
      popup.style.display = 'flex';
    }
  };

  /**
   * Cierra el popup de selección de ubicación
   */
  window.closeShippingPopup = () => {
    const popup = document.getElementById('shippingPopup');
    if (popup) {
      popup.style.display = 'none';
    }
  };

  /**
   * Guarda la ubicación seleccionada en el popup y cierra
   */
  window.saveShippingLocation = () => {
    const citySelect = document.getElementById('popupCitySelect');
    const provinceSelect = document.getElementById('popupProvinceSelect');
    
    if (!citySelect || !provinceSelect) return;
    
    const provinceSelected = provinceSelect.value !== '0';
    const citySelected = citySelect.value !== '0';
    
    if (!provinceSelected || !citySelected) {
      alert('Por favor selecciona una región y comuna');
      return;
    }
    
    // La sincronización ya se hizo en el evento change del select
    window.closeShippingPopup();
  };

  /**
   * Configura los event listeners del popup
   */
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.setupPopupListeners = (provinces, savedSelection) => {
    const popupProvinceSelect = document.getElementById('popupProvinceSelect');
    const popupCitySelect = document.getElementById('popupCitySelect');

    if (!popupProvinceSelect || !popupCitySelect || provinces.length === 0) return;

    // Cargar provincias en el popup
    const htmlRegionsPopup = provinces.reduce(
      (acc, region) =>
        acc + '<option value="' + region.provinceCode + '">' + region.provinceName + '</option>',
      '<option value="0">Selecciona una región</option>'
    );
    popupProvinceSelect.innerHTML = htmlRegionsPopup;
    
    // Evento cambio de provincia en popup
    popupProvinceSelect.addEventListener('change', function() {
      const selectedProvinceCode = this.value;
      popupCitySelect.innerHTML = '<option value="0">Selecciona una comuna</option>';
      popupCitySelect.disabled = (selectedProvinceCode === '0');
      popupCitySelect.value = '0';
      
      if (selectedProvinceCode !== '0') {
        const selectedProvince = provinces.find(x => x.provinceCode == selectedProvinceCode);
        if (selectedProvince) {
          let htmlCitiesPopup = '<option value="0">Selecciona una comuna</option>';
          selectedProvince.provinceCities.forEach(
            x => (htmlCitiesPopup += '<option value="' + x.cityName + '">' + x.cityName + '</option>')
          );
          popupCitySelect.innerHTML = htmlCitiesPopup;
        }
      }
      
      window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.saveSelection();
      window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.updateHeaderButton();
      window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.syncSelectors('popup', selectedProvinceCode, null);
      
      document.dispatchEvent(new CustomEvent('shipping:location:changed', {
        detail: { province: selectedProvinceCode, city: null }
      }));
    });
    
    // Evento cambio de ciudad en popup
    popupCitySelect.addEventListener('change', function() {
      const citySelected = this.value !== '0';
      
      if (citySelected) {
        const provinceCode = popupProvinceSelect.value;
        const cityName = this.options[this.selectedIndex].text;
        
        window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.saveSelection();
        window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.updateHeaderButton();
        window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.syncSelectors('popup', provinceCode, cityName);
        
        document.dispatchEvent(new CustomEvent('shipping:location:changed', {
          detail: { province: provinceCode, city: cityName }
        }));
      }
    });
    
    // Restaurar selección guardada en el popup
    if (savedSelection.province && savedSelection.province !== '0') {
      popupProvinceSelect.value = savedSelection.province;
      popupProvinceSelect.dispatchEvent(new Event('change'));
      
      setTimeout(() => {
        if (savedSelection.city) {
          for (let i = 0; i < popupCitySelect.options.length; i++) {
            if (popupCitySelect.options[i].text === savedSelection.city) {
              popupCitySelect.selectedIndex = i;
              break;
            }
          }
        }
      }, 300);
    }
  };
})();